module.exports = __webpack_public_path__ + "static/img3.afe813b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/section-integration/images/img3.png
// module id = 644
// module chunks = 132207355946902